import BcpAlert from "./BcpAlert";
import $ from 'jquery';
import moment from 'moment';
import 'slick-carousel/slick/slick';

let tmplBcpAlertBar = require("../../hbs-templates/bcpAlertBar.handlebars");

/**
 * @file BcpAlertBar.js
 */
class BcpAlertBar {
  constructor() {

    // Set defaults
    this.activeAlerts = null;

    // Get data
    this.getData();
  }

  /**
   * @type BcpAlert
   */
  activeAlerts() {
    get; set;
  }

  /**
   * Gets/sets data from the API
   */
  getData() {
    // Load session data
    this.getPersistedData();

    // If persisted data is empty, get data from API
    if (this.activeAlerts === null) {
      fetch(window.location.origin + '/api/alerts?_format=json',
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        }).then((response) => {
        if (response.ok) {
          response.json().then((r) => {
            // Persist the data
            this.setPersistedData(r);
            this.getPersistedData();
            this.render();
          });
        }
        else {
          console.log('Error getting data');
        }
      });
    } else {
      this.render();
    }
  }

  render() {
    if (this.activeAlerts !== null) {
      let renderData = {
        'className' : this.activeAlerts.alerts.length > 0 ? 'alert-container bg-red-medium' : 'alert-container bg-gray-dark',
        'alerts' : this.activeAlerts.alerts,
        'count': this.activeAlerts.alerts.length
      };

      $('#bcp-alert-bar').html(
        tmplBcpAlertBar(renderData)
      );

      // Start slider
      if (this.activeAlerts.alerts.length > 0) {
        $(".js-slider--bcp-alerts").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          cssEase: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
          dots: false,
          speed: 500,
          vertical: true,
        });
      }
    }
  }

  /**
   * Retrieves session data
   */
  getPersistedData() {
    let _alerts = window.sessionStorage.getItem('Loomis_BcpAlerts');
    if (_alerts) {

      // Parse the alerts
      _alerts = JSON.parse(_alerts);

      // Before returning the persisted alerts, check the timestamp
      let bcp = new BcpAlert(_alerts.timeStamp, _alerts.alerts);
      if (moment(bcp.timeStamp) <= moment().subtract(5, 'minutes')) {

        // Stale data, need to refresh
        this.clearPersistedData();
        this.activeAlerts = null;

      } else {

        // Data still fresh
        this.activeAlerts = bcp;
      }
    }
  };

  /**
   * Sets persisted data
   *
   * @param {Array<string>} alerts
   */
  setPersistedData(alerts) {
    let bcp = new BcpAlert(
      new Date(),
      alerts.length > 0 ? alerts : []
    );
    window.sessionStorage.setItem('Loomis_BcpAlerts', JSON.stringify(bcp));
  };

  /**
   * Clears persisted data
   */
  clearPersistedData() {
    window.sessionStorage.removeItem('Loomis_BcpAlerts');
  };
}

export default BcpAlertBar;


if (document.getElementById('bcp-alert-bar')) {
  let bcp = new BcpAlertBar();
}
